import { render, staticRenderFns } from "./Problemas.vue?vue&type=template&id=019ca1e4"
import script from "./Problemas.vue?vue&type=script&lang=js"
export * from "./Problemas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports